import { showDialog } from "../../../redux/dialogs/actions";
import { getDynamicTranslation } from "../../core/localization/localizationUtils";

/**
 * Creates the dialog shown when self booking requires a completed user address.
 * @param {() => void} action - Callback executed after the user confirms the dialog.
 * @returns {ReturnType<typeof showDialog>} The configured dialog action.
 */
const SelfBookingAddressRequiredDialog = (action: () => void) =>
  showDialog(
    {
      title: getDynamicTranslation(
        "dialogues.selfBookingAddressRequired.title",
        "layout"
      ),
      message: (
        <>
          {getDynamicTranslation("dialogues.selfBookingAddressRequired.text", "layout")}
        </>
      ),
      action,
      confirmButtonText: getDynamicTranslation(
        "dialogues.selfBookingAddressRequired.confirm",
        "layout"
      ),
    },
    true
  );

export default SelfBookingAddressRequiredDialog;
